<section class="cz-evaluation" [@fadeInUpAnimation]>
  <ng-container *ngIf="currentEvaluation$ | async as evaluation">
    <header class="page-header" *ngIf="evaluationLoaded">
      <div class="row">
        <div class="col-xs-2">
            <cz-user-name-link [user]="evaluation?.subject"
            [config]="badgeConfig"></cz-user-name-link>
        </div>
      </div>
      <h1 class="page-title">
        {{'$common_evaluation' | translate}}
      </h1>
      
    </header>
    <cz-evaluation-stepper *ngIf="evaluationLoaded"
                           [evaluation]="evaluation"
                           [currentUser]="currentUser"
                           [currentTask]="currentTask"
                           [reviews$]="reviews$"
                           [recommendationTemplates$]="recommendationTemplates$"
                           [recommendations$]="recommendations$"
                           [equipmentList$]="equipmentList$"
                           [equipmentRecommendations$]="equipmentRecommendations$"
                           [adminUsers]="adminUsers$ | async"
                           (equipmentOrderUpdated)="handleEquipmentOrderUpdated($event)"
                           (recommendationAdded)="handleRecommendationAdded($event)"
                           (recommendationUpdated)="handleRecommendationUpdated($event)"
                           (recommendationRemoved)="handleRecommendationRemoved($event)"
                           (reviewAdded)="handleReviewAdded($event)"
                           (reviewUpdated)="handleReviewUpdated($event)"
                           (reviewRemoved)="handleReviewRemoved($event)"></cz-evaluation-stepper>
  </ng-container>
</section>
